const Colors = {
  fontBlack: '#3c3d41',
  fontGrey: '#9b9b9b',
  fontDarkGrey: '#7f8fa4',
  softBlack: '#0e1111',
  mainOrange: '#f76b1c',
  mainGrey: '#979797',
  mainWhite: '#fff',
  mainRed: '#a60067',
  black: '#000',
  red: '#EF5350',
  lightGrey: '#acb3bc',
  link: '#61e1fb',
  mainPurple: '#6153cc',
  darkGrey: '#4a4a4a',
  window: '#eee',
  mainGreen: '#44ffd1',
  lightBorder: 'rgba(151, 151, 151, 0.3)',
  darkBorder: 'rgba(151, 151, 151, 0.8)',
  blankPicGrey: '#D9D9D9',
};

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const hexToRgbA = (hex, opacity = 1) => {
  let h = hex.replace('#', '');
  h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));
  for (let i = 0; i < h.length; i++) h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);
  if (typeof opacity != 'undefined') h.push(opacity);
  return 'rgba(' + h.join(',') + ')';
};

export const rgbToHex = (r, g, b) => {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

export default Colors;
